// src/pages/Registro/registro.jsx
import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import FormRegistro from "./formRegistro/formRegistro";
import newRequestUser from "../../api/cadastrar";

export default function Registro() {
  const navigate = useNavigate();
  const [nomeCompleto, setNomeCompleto] = useState("");
  const [email, setEmail] = useState("");
  const [cpf, setCpf] = useState("");
  const [condominioInfo, setCondominioInfo] = useState("");
  const [errorMessage, setErrorMessage] = useState("");
  const [successMessage, setSuccessMessage] = useState("");
  const [isLoading, setIsLoading] = useState(false);

  const handleContratar = () => navigate("/");

  const handleVoltar = () => {
    navigate(-1); // ou "/" se preferir voltar pra home
  };

  const handleChangeNome = (event) => {
    setNomeCompleto(event.target.value);
  };

  const handleChangeEmail = (event) => {
    setEmail(event.target.value.toLowerCase());
  };

  const handleChangeCpf = (event) => {
    // Se quiser só números:
    const value = event.target.value;
    setCpf(value);
  };

  const handleChangeCondominio = (event) => {
    setCondominioInfo(event.target.value);
  };

  // Validação de email
  const validarEmail = (email) => {
    const regex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return regex.test(email);
  };

  // Handler de submit
  const handleSubmit = async (event) => {
    event.preventDefault();
    setErrorMessage("");
    setSuccessMessage("");

    // Validações
    if (nomeCompleto.trim().length < 3) {
      setErrorMessage("Nome completo deve ter pelo menos 3 caracteres.");
      return;
    }

    const cpfDigits = cpf.replace(/\D/g, "");
    if (cpfDigits.length !== 11) {
      setErrorMessage("Por favor, insira um CPF válido (11 dígitos).");
      return;
    }

    if (!validarEmail(email)) {
      setErrorMessage("Por favor, insira um email válido.");
      return;
    }

    if (condominioInfo.trim().length < 2) {
      setErrorMessage("Por favor, insira o nome ou código do condomínio. Se preciso, colete o código com o sindico ou administrador do condominio.");
      return;
    }

    // Enviar requisição
    setIsLoading(true);
    try {
      const userData = {
        nomeCompleto,
        email,
        cpf: cpfDigits, // enviando somente dígitos
        condominioInfo,
      };

      await newRequestUser(userData);

      setSuccessMessage(
        "Solicitação enviada com sucesso! Aguarde a aprovação do responsável pelo condomínio. Você receberá um email de confirmação."
      );

      // Limpar formulário
      setTimeout(() => {
        setNomeCompleto("");
        setEmail("");
        setCpf("");
        setCondominioInfo("");
        navigate("/");
      }, 5000);
    } catch (err) {
      setErrorMessage(
        err.message || "Erro ao enviar solicitação. Tente novamente."
      );
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className="flex h-screen w-screen overflow-hidden">
      <div className="w-full">
        <FormRegistro
          nomeCompleto={nomeCompleto}
          email={email}
          cpf={cpf}
          condominioInfo={condominioInfo}
          errorMessage={errorMessage}
          successMessage={successMessage}
          isLoading={isLoading}
          onChangeNome={handleChangeNome}
          onChangeEmail={handleChangeEmail}
          onChangeCpf={handleChangeCpf}
          onChangeCondominio={handleChangeCondominio}
          onSubmit={handleSubmit}
          onClickVoltar={handleVoltar}
          onClickContratar={handleContratar}
        />
      </div>
    </div>
  );
}
